import BaseAPI from "../../baseAPI"

class TransactionAPI extends BaseAPI {
  constructor() {
    super("/store/transaction")
  }

  getAllTransactions(query) {
    return this.getByQuery("", query, true)
  }

  buyAgain(transactionId){
    return this.postByParam(`/${transactionId}/buy-again`, true)
  }
}

export { TransactionAPI as default }